import Clickable from '/components/Clickable';
import Icon from '/components/IconUpdated';
import Image from '/components/Image';
import PropTypes from 'prop-types';
import Typography from '/components/Typography';
import { useEffect, useRef } from 'react';

const Slots = ({ activeGroupIndex, emptySlots, packConfig, removeFromPack, packSizeOptions }) => {
	const scrollRef = useRef(null);
	const activeProductConfig = packConfig?.productConfigs?.[activeGroupIndex];
	let fixedPackSize = false;
	let slotsFixed = [];
	if (packConfig.packSize) {
		fixedPackSize = true;
		const packSizeOption = packSizeOptions.find(
			(option) => option.quantity === packConfig.packSize.quantity,
		);
		for (let i = 0; i < packSizeOption.quantity - packConfig.selectedProducts.length; i++) {
			slotsFixed.push({
				label: `Save ${packSizeOption.discount * 100}%`,
			});
		}
	}

	useEffect(() => {
		if (scrollRef.current) {
			if (packConfig.selectedProducts.length > 3) {
				scrollRef.current.scrollLeft = scrollRef.current.scrollWidth;
			} else {
				scrollRef.current.scrollLeft = 0;
			}
		}
	}, [packConfig.selectedProducts]);

	return (
		<div
			ref={scrollRef}
			className="max-w-[95vw] md:max-w-lg w-full overflow-x-auto scrollbar-hide"
			id="scrollbox">
			<div className="justify-center">
				<div
					className="flex gap-4 md:flex-wrap justify-left items-start"
					style={{
						minWidth: '100%',
						maxWidth: '100%',
						width:
							window.innerWidth < 768 && packConfig.selectedProducts.length > 3
								? `${packConfig.selectedProducts.length * 95}px`
								: '100%',
					}}>
					{packConfig.selectedProducts?.map((selectedProduct, selectedProductIndex) => {
						return (
							<div className="relative min-h-[115px]" key={selectedProductIndex}>
								<div className="bg-[#F8F7F5] rounded-full border-2 border-gray-600 p-2  w-[80px] h-[80px] md:h-[100px] md:w-[100px]">
									{selectedProduct.image && (
										<Image
											src={selectedProduct.image}
											className="rounded-full"
											height={100}
											width={100}
											objectFit="contain"
											alt={selectedProduct.title || 'Shinesty Product'}
										/>
									)}
								</div>

								<Clickable
									className="bg-gray-600 w-6 h-6 rounded-full text-white font-bold !-mt-3 absolute flex items-center justify-center mx-auto z-20 left-[calc(50%-12px)] hover:bg-[#595959]"
									onClick={() => removeFromPack(selectedProductIndex)}>
									<Icon name="closeWhite" width="12px" height="12px" />
								</Clickable>
							</div>
						);
					})}

					{!fixedPackSize &&
						emptySlots.map((slot, index) => {
							return (
								<div className="text-center" key={index}>
									<div className="bg-[#F8F7F5] rounded-full border-dashed border-2 border-gray-600 p-4  w-[80px] h-[80px] md:h-[100px] md:w-[100px]">
										{activeProductConfig?.productType?.img && (
											<Image
												src={activeProductConfig.productType.img}
												height={100}
												width={100}
												objectFit="contain"
												alt="next pair image"
											/>
										)}
									</div>

									<Typography className="whitespace-nowrap" variant="subtitle-sm">
										{slot.label}
									</Typography>
								</div>
							);
						})}
					{fixedPackSize &&
						slotsFixed.map((slot, index) => {
							return (
								<div className="text-center" key={index}>
									<div className="bg-[#F8F7F5] rounded-full border-dashed border-2 border-gray-600 p-4  w-[80px] h-[80px] md:h-[100px] md:w-[100px]">
										{activeProductConfig?.productType?.img && (
											<Image
												src={activeProductConfig.productType.img}
												height={100}
												width={100}
												objectFit="contain"
												alt="next pair image"
											/>
										)}
									</div>

									<Typography className="whitespace-nowrap" variant="subtitle-sm">
										{slot.label}
									</Typography>
								</div>
							);
						})}
				</div>
			</div>
		</div>
	);
};

Slots.propTypes = {
	activeGroupIndex: PropTypes.number,
	emptySlots: PropTypes.array,
	packConfig: PropTypes.object,
	packSizeOptions: PropTypes.array,
	removeFromPack: PropTypes.func,
};

export default Slots;
